import React, { Component } from "react";
import styled from "styled-components";
import NewJobPreviewDetails from "../../components/new-job-preview-details";
import { Helmet } from "react-helmet";
import { fetchSingleJob } from "../../../store/thunks/single-job";
import { isFavourited } from "../../../utils/favourites";
import { PageWrapper } from "../../components/page-wrapper";
import { Footer } from "../../components/footer";
import { JobInactive } from "../../components/job-inactive";
import { PopularCategories } from "../../components/popular-categories";
import { FavouriteButton } from "../../atoms/favourite-button";
import { PowerSearchHero } from "../../components/power-search-hero";

const getJobId = (url) => {
  return url.split("/")[2]; // Return the second part of the URL
};

const PreviewWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
`;

export class ShowSingleJob extends Component {
  static fetchData(store, url) {
    const jobId = getJobId(url);
    return store.dispatch(fetchSingleJob(jobId));
  }

  constructor(props) {
    super(props);
    this.state = {
      jobId: getJobId(this.props.location.pathname),
    };
  }

  componentDidMount() {
    const { job, location } = this.props;
    window.scrollTo(0, 0);

    if (
      (Object.keys(job).length === 0 && job.constructor === Object) ||
      `/${job.href}` !== location.pathname
    ) {
      this.props.fetchSingleJob(this.state.jobId);
    }
  }

  componentWillUnmount() {
    this.props.resetSingleJob();
  }

  createFavouriteJobObj() {
    const {
      category,
      company_name,
      date,
      href,
      id,
      job_type,
      title,
      remote_type,
    } = this.props.job;

    return {
      category: category,
      company_name: company_name,
      date: date,
      href: href,
      id: id,
      job_type: job_type,
      title: title,
      remote_type: remote_type,
    };
  }

  render() {
    const { job, favourited, handleFavouriteClick } = this.props;

    return (
      <div>
        <Helmet>
          <title>{this.props.pageTitle}</title>
          <meta name="description" content={this.props.pageDesc} />
          <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/medium-draft@0.5.18/dist/medium-draft.css"
            // href="https://unpkg.com/medium-draft/dist/medium-draft.css"
          />
          <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/medium-draft@0.5.18/dist/basic.css"
            // href="https://unpkg.com/medium-draft/dist/basic.css"
          />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@justremoteco" />
          <meta
            name="twitter:title"
            content={
              job && job.title ? `${job.title} at ${job.company_name}` : ""
            }
          />
          <meta name="twitter:description" content={this.props.pageDesc} />
          <meta
            name="twitter:image"
            content={
              job && job.company_logo
                ? `${job.company_logo.url}`
                : "https://remoteworker-live-superbrnds.s3.eu-west-2.amazonaws.com/Shareable/just_remote_logo.jpg"
            }
          />
        </Helmet>
        <PageWrapper>
          {Object.keys(job).length > 0 && job.constructor === Object && (
            <div>
              {job.inactive ? (
                <JobInactive job={job} />
              ) : (
                <div>
                  <PreviewWrapper>
                    <NewJobPreviewDetails job={job} />
                  </PreviewWrapper>
                  <FavouriteButton
                    onClick={() =>
                      handleFavouriteClick(this.createFavouriteJobObj())
                    }
                    favourited={isFavourited(job.id, favourited)}
                  />
                </div>
              )}
            </div>
          )}
        </PageWrapper>
        <PowerSearchHero
          tracking={{ action: "PowerSearch - Job Listing - BottomHero" }}
        />
        <PopularCategories />
        <Footer />
      </div>
    );
  }
}

export default ShowSingleJob;
